export interface IIntegrations {
  readonly id: string;
  readonly image: string;
  readonly alt: string;
}
const integration1 = require("img/integrations/gmail.svg") as string;
const integration2 = require("img/integrations/outlook.svg") as string;
const integration3 = require("img/integrations/slack.svg") as string;
const integration4 = require("img/integrations/trello.svg") as string;

export const IntegrationsData: Array<IIntegrations> = [
  {
    id: "1",
    image: integration1,
    alt: "gmail"
  },
  {
    id: "2",
    image: integration2,
    alt: "outlook"
  },
  {
    id: "3",
    image: integration3,
    alt: "slack"
  },
  {
    id: "4",
    image: integration4,
    alt: "trello"
  }
];



// WEBPACK FOOTER //
// ./src/components/integrations/integrations-data.ts